import service from './request';

// 首页banner图
export function selectNoticeLarge() {
  return service({
    url: '/dsc/web/selectNoticeLarge',
    method: 'get'
  });
}

// 首页轮播
export function selectNoticeCarousel() {
  return service({
    url: '/dsc/web/selectNoticeCarousel',
    method: 'get'
  });
}

// 架构
export function selectwyhAllList() {
  return service({
    url: '/dsc/wyh/selectwyhAllList',
    method: 'post'
  });
}

//列表
export function selectAreaNotice(data) {
    return service({
      url: '/dsc/web/selectAreaNotice',
      method: 'post',
      params: data
    });
}

// 详情
export function selectNoticeDetail(id) {
    return service({
      url: '/dsc/web/selectNoticeDetail?nbId='+id,
      method: 'post',
    });
}

// 相关文章
export function selectRelatedNotice(data) {
  return service({
    url: '/dsc/web/selectRelatedNotice',
    method: 'post',
    params: data
  });
}

// 上一篇
export function selectRelatedPreviousNotice(data) {
  return service({
    url: '/dsc/web/selectRelatedPreviousNotice',
    method: 'post',
    params: data
  });
}

// 下一篇
export function selectRelatedNextNotice(data) {
  return service({
    url: '/dsc/web/selectRelatedNextNotice',
    method: 'post',
    params: data
  });
}

